import { Injectable } from "@angular/core";
import { Data } from "@angular/router";
import { CheckoutVoucherService } from "./checkout-voucher.service";
import { PaymentContext } from "./checkout-payment.service";

export interface CheckoutComponentState {
  purchaseDetail: Data;
  userId: string;
  preferredCurrency: string;
  preferredCurrencySignal: () => string;
  selectedCard: string;
  selectedCardForAddCardCase?: string;
  prosub_id?: string;
  tp1?: string;
  tp2?: string;
  tp3?: string;
  t_id?: string;
  upsell_ID?: string;
  paymentOfferID?: string;
  other?: string;
  journeyId?: number;
  cardArrlength?: number;
  updatedPrizeValue?: number;
  customOfferAwardId?: number;
  userData?: Data;
  checkoutComPtype?: number;
  statusFlag?: boolean;
  updatedSuccessToast?: string;
  updatedFailureToast?: string;
  addonAmount?: Data[];
  totalAmount?: number;
  isCheckedValue?: string;
  dialogData?: Data;
  queryParams?: Data;
  scrollDepthProvider?: () => number;
}

@Injectable({ providedIn: "root" })
export class CheckoutParamsBuilderService {
  private state?: CheckoutComponentState;

  bind(state: CheckoutComponentState): void {
    this.state = state;
  }

  buildBaseParams(cardDetailId?: Data): PaymentContext {
    if (!this.state) {
      throw new Error("CheckoutParamsBuilderService state is not bound.");
    }

    return {
      purchaseDetail: this.state.purchaseDetail,
      cardDetailId,
      userId: this.state.userId,
      preferredCurrency: this.state.preferredCurrency,
      dialogData: this.state.dialogData,
      queryParams: this.state.queryParams,
      scrollDepthProvider: this.state.scrollDepthProvider,
      selectedCard: this.state.selectedCard,
      selectedCardForAddCardCase: this.state.selectedCardForAddCardCase,
      prosub_id: this.state.prosub_id,
      tp1: this.state.tp1,
      tp2: this.state.tp2,
      tp3: this.state.tp3,
      t_id: this.state.t_id,
      upsell_ID: this.state.upsell_ID,
      paymentOfferID: this.state.paymentOfferID,
      other: this.state.other,
      journeyId: this.state.journeyId,
      cardArrlength: this.state.cardArrlength,
      customOfferAwardId: this.state.customOfferAwardId,
      preferredCurrencySignal: this.state.preferredCurrencySignal,
      userData: this.state.userData,
      checkoutComPtype: this.state.checkoutComPtype,
      statusFlag: this.state.statusFlag,
    };
  }

  buildFullParams(voucherService: CheckoutVoucherService, cardDetailId?: Data): PaymentContext {
    const context = this.buildBaseParams(cardDetailId);
    context.selectedDiscountValue = voucherService.getSelectedDiscountValue();
    context.selectedDiscountVoucherData = voucherService.getSelectedVoucherData();
    return context;
  }

  buildAddNewCardParams(
    voucherService: CheckoutVoucherService,
    extras: {
      dialogData?: Data;
      queryParams?: Data;
      scrollDepthProvider?: () => number;
      cardDetailId?: Data;
    }
  ): PaymentContext {
    const context = this.buildFullParams(voucherService, extras.cardDetailId);
    context.dialogData = extras.dialogData;
    context.queryParams = extras.queryParams;
    context.scrollDepthProvider = extras.scrollDepthProvider;
    context.selectedCardForAddCardCase = this.state?.selectedCardForAddCardCase;
    context.updatedPrizeValue = this.state?.updatedPrizeValue;
    context.isCheckedValue = this.state?.isCheckedValue;
    context.addonAmount = this.state?.addonAmount;
    context.totalAmount = this.state?.totalAmount;
    return context;
  }

  buildCardOfferParams(cardDetailId?: Data): PaymentContext {
    const context = this.buildBaseParams(cardDetailId);
    context.successToast = this.state?.updatedSuccessToast;
    context.failureToast = this.state?.updatedFailureToast;
    return context;
  }
}
